import {addMonths} from 'date-fns';

import {SetValueConfig, UseFormReturn} from 'react-hook-form';

import {getApiDateString, parseDate} from 'shared/web';

import {BaseVehicle} from '../../types/BaseVehicle';
import {FluidReplacementServiceIntervals} from '../../types/RentalVehicle';

export interface FormCalculateFluidNextReplacementDateFromLastDateActionParams {
  form: UseFormReturn<BaseVehicle>;
  name: FluidReplacementServiceIntervals;
  value: string | null;
}

const DEFAULT_OPTIONS = {
  shouldDirty: true,
  shouldValidate: true,
} satisfies SetValueConfig;

/**
 * XState action for calculating the next fluid replacement date when the last replacement date changes.
 * Uses the last replacement date and the months interval to calculate the next replacement date.
 *
 * @param _context - XState context (unused)
 * @param params - Parameters containing form instance, fluid name and last replacement date value
 */
export const formCalculateFluidNextReplacementDateFromLastDateAction = (
  _context: unknown,
  params: FormCalculateFluidNextReplacementDateFromLastDateActionParams
): void => {
  const {form, name, value} = params;

  const lastReplacementDate = parseDate(value);
  const lastReplacementMonths = form.getValues(`serviceIntervals.${name}.nextReplacementMileage`);

  if (!lastReplacementDate || !lastReplacementMonths) {
    return;
  }

  const nextDate = addMonths(lastReplacementDate, lastReplacementMonths);

  form.setValue(
    `serviceIntervals.${name}.nextReplacementDate`,
    getApiDateString(nextDate),
    DEFAULT_OPTIONS
  );
};
